import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'data';
import { slice } from './slice';

export const fieldsReducer = slice.reducer;
export * from './actions';
export * from './store';

export const fieldsStoreSelector = createSelector(
  (state: RootState) => state.fields,
  (fields) => fields,
);
